<template>
  <v-layout class="main-wrapper" column>
    <v-app-bar color="neutral1" dense app flat>
      <v-btn class="btn-icon" icon @click="handleDrawer()">
        <v-icon>mdi-menu</v-icon>
      </v-btn>

      <div
        v-if="$vuetify.breakpoint.smAndUp"
        class="pl-2 text-h6 font-weight-regular neutral6--text"
      >
        {{ $route?.meta?.title }}
      </div>

      <v-spacer />

      <v-avatar size="2.125rem" color="neutral1">
        <v-icon color="neutral4" small>fas fa-user</v-icon>
      </v-avatar>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      class="side-drawer rounded-r-xl"
      color="neutral"
      width="300"
      floating
      app
    >
      <div class="d-flex flex-column fill-height">
        <div class="d-flex justify-center mt-3 mb-6">
          <v-img
            :src="require(`@/assets/logotype.png`)"
            height="2rem"
            max-width="12rem"
            contain
          />
        </div>

        <div class="custom-divider mb-6" />

        <v-list class="py-0 px-4 transparent" nav>
          <router-link
            v-for="(item, i) in _routes"
            v-slot="{ href, navigate, isActive }"
            :to="item.path"
            :key="i"
            custom
          >
            <v-list-item
              class="mb-2 rounded-lg"
              :class="{ neutral1: isActive }"
              :href="href"
              @click="navigate"
            >
              <v-list-item-icon class="mx-2">
                <v-icon :color="isActive ? 'primary' : ''" small>
                  {{ item.icon }}
                </v-icon>
              </v-list-item-icon>

              <v-list-item-title
                :class="{ 'primary--text font-weight-medium': isActive }"
              >
                {{ item.label }}
              </v-list-item-title>
            </v-list-item>
          </router-link>
        </v-list>

        <v-spacer />

        <v-list class="pt-0 px-4 transparent" nav>
          <v-list-item class="rounded-lg" @click="signOut()">
            <v-list-item-icon class="mx-2">
              <v-icon> mdi-logout </v-icon>
            </v-list-item-icon>

            <v-list-item-title> Sair </v-list-item-title>
          </v-list-item>
        </v-list>
      </div>
    </v-navigation-drawer>

    <router-view />
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Main",

  data() {
    return {
      drawer: true,
      mini: false,
    };
  },

  computed: {
    ...mapGetters({
      _user: "user",
    }),

    _routes() {
      return [
        {
          icon: "fas fa-home",
          label: "Dashboard",
          path: "/home",
        },
        {
          icon: "fas fa-building",
          label: "Empreendimentos",
          path: "/assets",
        },
        {
          icon: "fas fa-exchange-alt",
          label: "Transações",
          path: "/transactions",
        },
        {
          icon: "fas fa-users",
          label: "Usuários",
          path: "/users",
        },
      ];
    },
  },

  methods: {
    handleDrawer() {
      this.drawer = !this.drawer;
    },

    signOut() {
      this.$root.$emit("sign-out");
    },
  },
};
</script>

<style lang="scss" src="./style.scss" scoped />
